import { createContext } from 'react';

/**
 * `wide` is the contact page layout. `compact` is for narrow views such as the
 * conversation sidebar: summary items get a row each and the expand chevron
 * sits under the timestamp.
 */
export const UserActivityLayoutContext = createContext<'wide' | 'compact'>(
  'wide',
);
